import CampaignIcon from '@mui/icons-material/CampaignRounded';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { BrandVoiceName } from 'features/brand-voice/components/BrandVoiceName';
import { BrandVoiceThumbnailAvatar } from 'features/brand-voice/components/BrandVoiceThumbnailAvatar';
import { MouseEvent, ReactNode } from 'react';
import { ModelsBrandVoice } from 'services/backofficeIntegration/http/endpoints/new-brand-voice/httpCreateBrandVoice';
import styled from 'styled-components';
import useTr from 'utils/hooks/useTr';

type Props = {
  brandVoices: ModelsBrandVoice[];
  selectedId: string;
  defaultMessage?: ReactNode;
  onClick?: (event: MouseEvent) => void;
  onMouseDown?: (event: MouseEvent) => void;
};

export const BrandVoiceSelectRenderValue = ({
  brandVoices,
  selectedId,
  onClick,
  onMouseDown
}: Props) => {
  const brandVoice = brandVoices.find(brandVoice => brandVoice.id === selectedId);
  const translate = useTr();
  return (
    <Tooltip title={translate('chat.message_input.brand_voice.tooltip')}>
      <StyledIconButton size="small" onClick={onClick} onMouseDown={onMouseDown}>
        {!brandVoice ? (
          <CampaignIcon />
        ) : (
          <BrandVoiceThumbnailAvatar thumbnailUrl={brandVoice.thumbnailUrl} size={24} />
        )}
      </StyledIconButton>
    </Tooltip>
  );
};

const Root = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacings.two};
  cursor: pointer;
`;

const StyledIconButton = styled(IconButton)`
  border: 1px solid ${({ theme }) => theme.colors.divider};
`;
